import isObject from './isObject';

const getQueryString = url => url.split('?')[1];

const hasQueryString = url => !!getQueryString(url);

// converts an object to a query string
// { prop1: 'val1', prop2: 'val2 } => 'prop1=val1&prop2=val2'
const objectToQueryString = params => (
  Object
    .keys(params)
    .reduce((accumulator, currentValue) => (
      `${accumulator}${currentValue}=${params[currentValue]}&`
    ), '')
    .replace(/&$/, '')
);

// converts a query string to an object
// 'prop1=val1&prop2=val2' => { prop1: 'val1', prop2: 'val2 }
const queryStringToObject = queryString => (
  queryString
    .split('&')
    .reduce((accumulator, currentValue) => {
      const [key, value] = currentValue.split('=');

      if (key && value) {
        // eslint-disable-next-line no-param-reassign
        accumulator[key] = value;
      }

      return accumulator;
    }, {})
);

export const appendToQueryString = (url = '', params) => {
  if (!isObject(params)) {
    return url;
  }

  const queryString = objectToQueryString(params);

  if (!queryString) {
    return url;
  }

  return hasQueryString(url) ? `${url}&${queryString}` : `${url}?${queryString}`;
};

export const removeFromQueryString = (url = '', paramNames) => {
  if (!hasQueryString(url) || !Array.isArray(paramNames)) {
    return url;
  }

  const params = queryStringToObject(getQueryString(url));

  paramNames.forEach(paramName => delete params[paramName]);

  const queryString = objectToQueryString(params);
  const [urlWithoutQueryString] = url.split('?');

  if (!queryString) {
    return urlWithoutQueryString;
  }

  return `${urlWithoutQueryString}?${queryString}`;
};
